import { useDispatch, useSelector } from 'react-redux';
import NavbarV2 from '../../components/navbarV2/NavbarV2';
import './OrderV2.css';
import { useEffect, useState } from 'react';
import CartList from '../../components/CartList/CartList';
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import { clearCart } from '../../redux/cartSlice';
import PaymentOptions from '../../components/PaymentOptions/PaymentOptions';
import { Tooltip } from '@mui/material';
import {
    SMALL_ORDER_SURCHARGE_THRESHOLD_EUR,
    SMALL_ORDER_SURCHARGE_EUR,
} from '../../pricing';
import { ClipLoader } from 'react-spinners';
import { formatMoney } from '../../utils/formatMoney';

const tip = (<div><strong>DELIVERY WILL BE DONE THE FOLLOWING WEEK WHEN WE RECEIVE THE PAYMENT UNTIL TUESDAY WEATHER AND CONDITIONS PERMITTING:</strong><br></br>
DELIVERIES AT ADDRESSES IN THE FOLLOWING LOCATIONS IN MALTA WILL BE DONE ON A TUESDAY AS PER THE INDICATED ROUTE:<br></br>
VALLETTA, SANTA VENERA,HAMRUN, PIETA,FLORIANA, MSIDA, TA'XBIEX, GZIRA, SLIEMA, ST.JULIANS, SAN GWANN, SWIEQI, MADLIENA, PEMBROKE, BAHAR IC-CAGHAQ<br></br><br></br>

DELIVERIES AT ADDRESSES IN THE FOLLOWING LOCATIONS IN MALTA WILL BE DONE ON A WEDNESDAY AS PER THE INDICATED ROUTE:<br></br>
 BIRKIRKARA, SWATAR, IKLIN, BALZAN, LIJA, ATTARD, MOSTA,NAXXAR, GHARGHUR, BURMARRAD, SAN PAWL IL-BAHAR, MELLIEHA, MANIKATA, MGARR,MTARFA, RABAT, DINGLI<br></br><br></br>

DELIVERIES AT ADDRESSES IN THE FOLLOWING LOCATIONS IN MALTA WILL BE DONE ON A THURSDAY AS PER THE INDICATED ROUTE:<br></br>
ZEBBUG, SIGGIEWI, QORMI, MARSA,BORMLA, BIRGU, ISLA, KALKARA, FGURA, PAOLA ,TARXIEN,SANTA LUCIJA, XGHAJRA,ZABBAR, MARSASCALA, ZEJTUN ,MARSAXLOKK, BIRZEBBUGIA, GHAXAQ ,GUDJA, KIRKOP ,MQABBA,SAFI ,ZURRIEQ, QRENDI,LUQA<br></br><br></br>

DELIVERIES AT ADDRESSES IN THE FOLLOWING LOCATIONS IN GOZO WILL BE DONE ON A FRIDAY AS PER THE INDICATED ROUTE:<br></br>
GHAJNSIELEM, QALA, XEWKIJA,NADUR, XAGHRA,SANNAT,KERCEM, MUNXAR,VICTORIA, FONTANA, XLENDI, GHARB,GHASRI, SAN LAWRENZ ,ZEBBUG ,MARSALFORN</div>);

const normalizeIkeaArticleId = (raw) => {
    const s = String(raw || '').trim();
    const stripped = s.replace(/^s/i, '');
    const digits = stripped.replace(/\D/g, '');
    return digits || stripped;
};

const OrderV2 = () => {
    const cart = useSelector((state) => state.cartReducer.items)
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const [cartItems, setCartItems] = useState([]);
    const [stockLoading, setStockLoading] = useState(false);
    const [account, setAccount] = useState({});
    const [surcharge, setSurcharge] = useState(0);
    const [shipping, setShipping] = useState(0);
    const [VAT, setVAT] = useState(0);
    const [total, setTotal] = useState(0);
    const [selectedOption, setSelectedOption] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [pickup, setPickup] = useState(() => Boolean(location.state?.pickup));

    useEffect(() => {
        getAccount();
    }, []);

    const mapCartItems = async () => {
        if (cart.length === 0) {
            setCartItems([]);
            setStockLoading(false);
            return;
        }

        setStockLoading(true);

        try {
            const ikeaIds = [...new Set(
                cart.filter((item) => String(item.id).length <= 20).map((item) => normalizeIkeaArticleId(item.id)),
            )].filter(Boolean);

            let itemsMap = {};
            if (ikeaIds.length > 0) {
                try {
                    const response = await fetch(`${process.env.REACT_APP_API}/api/ikea/stock`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ articleIds: ikeaIds }),
                    });
                    const data = await response.json();
                    if (data.items) {
                        itemsMap = data.items;
                    }
                } catch (error) {
                    console.error('Error fetching IKEA stock:', error);
                }
            }

            const items = cart.map((item) => {
                let stock = null;
                let probability = null;
                if (String(item.id).length <= 20) {
                    const key = normalizeIkeaArticleId(item.id);
                    const row = itemsMap[key];
                    if (row?.ok) {
                        stock = row.stock;
                        probability = row.probability;
                    }
                }
                return {
                    ...item,
                    stock,
                    probability,
                };
            });

            setCartItems(items);
        } finally {
            setStockLoading(false);
        }
    };

    useEffect(() => {
        mapCartItems();
    }, [cart]);

    useEffect(() => {
        calculateTotal(cart)
    }, [cart, pickup]);

    useEffect(() => {
        calculateVAT(cart)
    }, [surcharge]);

    useEffect(() => {
        calculateVAT(cart)
    }, [shipping]);

    const calculateTotal = (cart) => {
        let sum = 0;

        cart.forEach(item => {
            sum += (item.price * item.amount)
        });

        setTotal(sum);
        calculateSurcharge(cart);
        calculateShipping(cart);
    }

    const calculateSurcharge = (cart) => {
        let sum = 0;

        cart.forEach(item => {
            sum += (item.price * item.amount)
        });

        if (sum === 0) setSurcharge(0)
        else if (pickup) setSurcharge(0)
        else if (sum < SMALL_ORDER_SURCHARGE_THRESHOLD_EUR) setSurcharge(SMALL_ORDER_SURCHARGE_EUR)
        else setSurcharge(0)
    }

    const calculateShipping = (cart) => {
        let sum = 0;

        cart.forEach(item => {
            sum += (item.price * item.amount)
        });

        if (new Date() < new Date('2025-09-16')) {
            if (sum > 500) setShipping(sum * 0.23)
            else setShipping(sum * 0.25)
        } else {
            if (sum > 500) setShipping(sum * 0.28)
            else setShipping(sum * 0.30)
        }
    }

    const calculateVAT = (cart) => {
        let sum = 0;

        cart.forEach(item => {
            sum += (item.price * item.amount)
        });

        setVAT((sum + surcharge + shipping) / 1.18 * 0.18);
    }

    const getAccount = () => {
        if (localStorage.getItem('account') == null) navigate('/login')
        fetch(`${process.env.REACT_APP_API}/api/getAccount/${localStorage.getItem('account')}`, {})
        .then(response => {
            if (response.status === 200) {
                response.json().then(data => {
                    setAccount(data);
                });
            }
        })
    }

    const order = (payLater = false) => {     
        const name = document.getElementById("name").value;
        const campanyName = document.getElementById("campanyName").value;
        const VAT = document.getElementById("VAT").value;
        const street = document.getElementById("street").value;
        const city = document.getElementById("city").value;
        const postCode = document.getElementById("postCode").value;
        const phone = document.getElementById("phone").value;
        const email = document.getElementById("email").value;
        const deliveryname = document.getElementById("delivery-name").value;
        const deliverycampanyName = document.getElementById("delivery-campanyName").value;
        const deliveryVAT = document.getElementById("delivery-VAT").value;
        const deliverystreet = document.getElementById("delivery-street").value;
        const deliverycity = document.getElementById("delivery-city").value;
        const deliverypostCode = document.getElementById("delivery-postCode").value;
        const deliveryphone = document.getElementById("delivery-phone").value;
        const deliveryemail = document.getElementById("delivery-email").value;
        const note = document.getElementById("note").value;

        if (name === "") {
            toast.error('Name is required.');
            return;
        }
        if (street === "") {
            toast.error('Street is required.');
            return;
        }
        if (city === "") {
            toast.error('City is required.');
            return;
        }
        if (postCode === "") {
            toast.error('Post Code is required.');
            return;
        }
        if (phone === "") {
            toast.error('Phone is required.');
            return;
        }
        if (email === "") {
            toast.error('Email is required.');
            return;
        }
        if (deliveryname === "") {
            toast.error('Name is required.');
            return;
        }
        if (deliverystreet === "") {
            toast.error('Street is required.');
            return;
        }
        if (deliverycity === "") {
            toast.error('City is required.');
            return;
        }
        if (deliverypostCode === "") {
            toast.error('Post Code is required.');
            return;
        }
        if (deliveryphone === "") {
            toast.error('Phone is required.');
            return;
        }
        if (deliveryemail === "") {
            toast.error('Email is required.');
            return;
        }

        setLoading(true);

        fetch(`${process.env.REACT_APP_API}/api/order`, {
            method: 'POST',
            
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify({
                account: localStorage.getItem('account'),
                name: name,
                campanyName: campanyName,
                VAT: VAT,
                street: street,
                city: city,
                postCode: postCode,
                phone: phone,
                email: email,
                deliveryname: deliveryname,
                deliverycampanyName: deliverycampanyName,
                deliveryVAT: deliveryVAT,
                deliverystreet: deliverystreet,
                deliverycity: deliverycity,
                deliverypostCode: deliverypostCode,
                deliveryphone: deliveryphone,
                deliveryemail: deliveryemail,
                note: note,
                cart: cart,
                payLater : payLater,
                method : selectedOption,
                pickup,
            })
        })
        .then(response => {
            setLoading(false);
            if (response.status === 200) {
                response.json().then(data => {
                    dispatch(clearCart());
                    toast.success('Order Submitted!')
                    if (payLater) {
                        navigate('/');
                    } else {
                        window.location = `https://www.vivapayments.com/web/checkout?ref=${data.orderCode}&color=8CBD22`;
                    }
                });
            } else {
                response.json().then((data) => {
                    const msg =
                        typeof data === 'string'
                            ? data
                            : data?.message || 'Order could not be placed.';
                    toast.error(msg);
                }).catch(() => toast.error('Order could not be placed.'));
            }
        });
    }

    const setOption = (option) => {
        setSelectedOption(option);
    }

    return (
        <div className="v2-page orderv2">
            <NavbarV2 />

            <div className="v2-container orderv2-inner">
                <h1 className="v2-h1">Checkout</h1>
                <p className="v2-muted orderv2-lead">
                    Billing and delivery must match Malta delivery requirements. VAT is included in product prices.
                </p>

                <div className="v2-grid-2 orderv2-address-grid">
                    <div className="v2-card orderv2-card">
                        {account && (
                            <form>
                                <h2 className="v2-card-title">Billing details</h2>

                                <div className="v2-field">
                                    <label htmlFor="name">Full name</label>
                                    <input type="text" name="name" defaultValue={account.name} id="name" />
                                </div>
                                <div className="v2-field">
                                    <label htmlFor="campanyName">Company name</label>
                                    <input type="text" name="campanyName" defaultValue={account.campany} id="campanyName" />
                                </div>
                                <div className="v2-field">
                                    <label htmlFor="VAT">VAT no.</label>
                                    <input type="text" name="VAT" defaultValue={account.VAT} id="VAT" />
                                </div>
                                <div className="v2-field">
                                    <label htmlFor="street">Street address</label>
                                    <input type="text" name="street" defaultValue={account.street} id="street" />
                                </div>
                                <div className="v2-field">
                                    <label htmlFor="city">Town / city</label>
                                    <input type="text" name="city" defaultValue={account.city} id="city" />
                                </div>
                                <div className="v2-field">
                                    <label htmlFor="postCode">Post code</label>
                                    <input type="text" name="postCode" defaultValue={account.postCode} id="postCode" />
                                </div>
                                <div className="v2-field">
                                    <label htmlFor="phone">Phone</label>
                                    <input type="tel" name="phone" defaultValue={account.phone} id="phone" />
                                </div>
                                <div className="v2-field">
                                    <label htmlFor="email">Email</label>
                                    <input type="email" name="email" defaultValue={account.email} id="email" />
                                </div>
                            </form>
                        )}
                    </div>

                    <div className="v2-card orderv2-card">
                        <form>
                            <h2 className="v2-card-title">Delivery details</h2>

                            <div className="v2-field">
                                <label htmlFor="delivery-name">Full name</label>
                                <input type="text" name="delivery-name" defaultValue={account.name} id="delivery-name" />
                            </div>
                            <div className="v2-field">
                                <label htmlFor="delivery-campanyName">Company name</label>
                                <input type="text" name="delivery-campanyName" defaultValue={account.campany} id="delivery-campanyName" />
                            </div>
                            <div className="v2-field">
                                <label htmlFor="delivery-VAT">VAT no.</label>
                                <input type="text" name="delivery-VAT" defaultValue={account.VAT} id="delivery-VAT" />
                            </div>
                            <div className="v2-field">
                                <label htmlFor="delivery-street">Street address</label>
                                <input type="text" name="delivery-street" defaultValue={account.street} id="delivery-street" />
                            </div>
                            <div className="v2-field">
                                <label htmlFor="delivery-city">Town / city</label>
                                <input type="text" name="delivery-city" defaultValue={account.city} id="delivery-city" />
                            </div>
                            <div className="v2-field">
                                <label htmlFor="delivery-postCode">Post code</label>
                                <input type="text" name="delivery-postCode" defaultValue={account.postCode} id="delivery-postCode" />
                            </div>
                            <div className="v2-field">
                                <label htmlFor="delivery-phone">Phone</label>
                                <input type="tel" name="delivery-phone" defaultValue={account.phone} id="delivery-phone" />
                            </div>
                            <div className="v2-field">
                                <label htmlFor="delivery-email">Email</label>
                                <input type="email" name="delivery-email" defaultValue={account.email} id="delivery-email" />
                            </div>
                        </form>
                    </div>
                </div>

                <div className="v2-card orderv2-note-card">
                    <form>
                        <h2 className="v2-card-title">Order note</h2>
                        <div className="v2-field">
                            <label htmlFor="note">Instructions for Sicily (optional)</label>
                            <textarea name="note" id="note" />
                        </div>
                    </form>
                </div>

                <div className="orderv2-cart-grid">
                    <div className="v2-mui-scope orderv2-mui">
                        {stockLoading && (
                            <p className="v2-muted orderv2-stock-msg">
                                <ClipLoader color="#C4603C" size={14} />
                                Checking stock…
                            </p>
                        )}
                        <CartList data={cartItems} showcase noMargin stockLoading={stockLoading} />
                    </div>

                    <div className="v2-card orderv2-pay-card">
                        <h2 className="v2-card-title">Payment</h2>
                        <p className="v2-muted orderv2-vat-caption">Prices include VAT where applicable.</p>

                        <label className="v2-note v2-callout">
                            <input
                                type="checkbox"
                                checked={pickup}
                                onChange={(e) => setPickup(e.target.checked)}
                            />
                            {total < SMALL_ORDER_SURCHARGE_THRESHOLD_EUR ? (
                                <span>
                                    Warehouse pickup — waive the €{SMALL_ORDER_SURCHARGE_EUR} small-order surcharge
                                    only (orders under €{SMALL_ORDER_SURCHARGE_THRESHOLD_EUR} product total). Shipping
                                    to our warehouse still applies.
                                </span>
                            ) : (
                                <span>Pick up</span>
                            )}
                        </label>

                        <div className="v2-price-row">
                            <p>Products</p>
                            <h4>€{formatMoney(total)}</h4>
                        </div>
                        <div className="v2-price-row">
                            <p>Shipping</p>
                            <h4>€{formatMoney(shipping)}</h4>
                        </div>
                        <div className="v2-price-row">
                            <p>Surcharge</p>
                            <h4>€{formatMoney(surcharge)}</h4>
                        </div>
                        <div className="v2-divider" />
                        <div className="v2-price-row v2-grand-total">
                            <p>Grand total</p>
                            <h4>€{formatMoney(total + surcharge + shipping)}</h4>
                        </div>

                        <PaymentOptions setOption={setOption} />

                        <div className="orderv2-actions">
                            {selectedOption === 'vivaWallet' && (
                                <button type="button" disabled={loading} className="v2-btn v2-btn--primary" onClick={() => order(false)}>
                                    Confirm & pay
                                </button>
                            )}
                            <button type="button" disabled={loading} className="v2-btn v2-btn--secondary" onClick={() => order(true)}>
                                Confirm & pay later
                            </button>
                        </div>

                        <div className="cartv2-legal">
                            <p className="v2-muted">
                                Delivery timing depends on stock at the retailer — reach out by email when you need
                                certainty.
                            </p>
                            <p className="v2-muted">
                                Regions and weekdays — see the delivery{' '}
                                <Tooltip disableFocusListener title={tip} placement="top">
                                    <span className="cartv2-schedule-link">schedule</span>
                                </Tooltip>.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderV2;